/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sport/games/connected': {
    width: 16,
    height: 16,
    viewBox: '0 0 120 120',
    data: '<defs><path pid="0" id="svgicon_sport_games_connected_a" d="M40 0H20v40h20a20 20 0 000-40m20 20h20"/><g id="svgicon_sport_games_connected_b"><use href="#svgicon_sport_games_connected_a"/><path pid="1" class="male" d="M20 12H0m20 16H0"/></g></defs><use href="#svgicon_sport_games_connected_b" transform="rotate(135 23.088 51.74)"/><use href="#svgicon_sport_games_connected_a" transform="rotate(-45 79.941 -29.113)"/>'
  }
})
